// extracted by mini-css-extract-plugin
export var hidden = "_44-1";
export var leftPanel = "_44-2";
export var readonlyInspector = "_44-3";
export var rightPanel = "_44-0";